var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cp-tabs_active-bar"},[_c('span',{ref:"bar",style:(_vm.barStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }